const isFeatureEnabled = (featureFlag: string): boolean => {
    return featureFlag === "on";
}

export default isFeatureEnabled;